import isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import React from 'react';
import { MOVIE_DETAIL, MOVIE_REVIEWS, SHOW_LISTING } from '../../constants/moviesConst';
import { useAppSelector } from '../../hooks/hooks';
import { movieSessionsErrorSelector } from '../../redux/slices/movies/selectors';
import { getMovieDetailUrl } from '../../services/urlCreator';
import Link from '../Link/Link';
import LinksList, { LinksListItem } from '../LinksList/LinksList';

interface Props {
	movieDetails: any;
	selectedTab: string;
	contentId: string;
	clickEvent: any;
}

const MDPTabs = ({ movieDetails, selectedTab, contentId, clickEvent }: Props) => {
	const router = useRouter();
	const movieSessionsError = useAppSelector(movieSessionsErrorSelector);

	const { query } = router;

	const { frmtid, tab, fromdate, moviecode } = query;

	const getTabs = (): LinksListItem[] => {
		let tabs = [];

		if (!isEmpty(movieDetails.languageFormatGroups) || frmtid) {
			tabs.push({
				name: 'Showtimings',
				selected: selectedTab === SHOW_LISTING,
				itemKey: SHOW_LISTING,
				child: (
					<Link
						to={
							getMovieDetailUrl(movieDetails.name, contentId) +
								`${frmtid && !movieSessionsError ? `?frmtid=${frmtid}` : ''}${
									fromdate ? `&fromdate=${fromdate}` : ''
								}${moviecode ? `&moviecode=${moviecode}` : ''}` || ''
						}
						replace
					>
						Showlisting
					</Link>
				),
			});
		}

		if (!isEmpty(movieDetails.languageFormatGroups) || frmtid || !isEmpty(movieDetails.ratings)) {
			tabs.push({
				name: 'About Movie',
				selected: selectedTab === MOVIE_DETAIL,
				itemKey: MOVIE_DETAIL,
				child: (
					<Link
						onClick={() => clickEvent && clickEvent('About tab Clicked')}
						to={
							getMovieDetailUrl(movieDetails.name, contentId) +
								`?tab=about${frmtid ? `&frmtid=${frmtid}` : ''}${
									fromdate ? `&fromdate=${fromdate}` : ''
								}${moviecode ? `&moviecode=${moviecode}` : ''}` || ''
						}
						replace
					>
						About Movie
					</Link>
				),
			});
		}

		if (!isEmpty(movieDetails.ratings)) {
			tabs.push({
				name: 'Critic Reviews',
				selected: selectedTab === MOVIE_REVIEWS,
				itemKey: MOVIE_REVIEWS,
				child: (
					<Link
						onClick={() => clickEvent && clickEvent('Review Tab Clicked')}
						to={
							getMovieDetailUrl(movieDetails.name, contentId) +
								`?tab=reviews${frmtid ? `&frmtid=${frmtid}` : ''}${
									fromdate ? `&fromdate=${fromdate}` : ''
								}${moviecode ? `&moviecode=${moviecode}` : ''}` || ''
						}
						replace
					>
						Reviews
					</Link>
				),
			});
		}

		return tabs;
	};
	return <LinksList linkClass items={getTabs()} />;
};

export default MDPTabs;
